import {InjectionToken, ModuleWithProviders} from "@angular/core";
import {Type} from "@angular/core/src/type";
import {Provider} from "@angular/core/src/di";

export const INJECTION_MODULE_TOKEN = new InjectionToken('injection-config');

export interface InjectionModuleConfig {
  [key: string]: Provider | Array<Type<any> | any[]> | Array<Type<any> | ModuleWithProviders | any[]> | any,
}

export interface ParseFileVO {
  parseRows: Array<any>;
  rowsIndexError: Array<any>;
  rows: Array<any>
  rowsError: Array<any>;
  prepareRowsError: Array<any>;
  indexRows: Array<any>;
  blocks?: Array<any>;
  [key: string]: any;
}

export interface DataBlockVO {
  start: string;
  end: string;
  color: string;
  data: any
}

export interface DataSetVO {
  id: string;
  label: string;
  blocks: DataBlockVO[]
}

export const defaultConfig: InjectionModuleConfig = {
  blockTemps: null
};

export const MOTIFS = ['MY_TIME_KO', 'ABSENCES', 'WITHOUT_REALIZED', 'WITHOUT_PLANNED', 'PLANNED_ERROR', 'REALIZED_ERROR', 'OTHER'];


export const MOCK_HISTORIES = [{
  "id": 3,
  "vo": "[{\"debut\":\"2023-04-05 10:00:01\",\"fin\":\"2023-04-05 12:00\"},{\"debut\":\"2023-04-05 13:00\",\"fin\":\"2023-04-05 23:00:06\"}]",
  "motif": "TEST",
  "pause": 45,
  "status": "PENDING",
  "site_id": 287,
  "added_by": "000167",
  "timezone": 1,
  "site_name": "MA-HASSANE2",
  "created_at": "2023-04-13 11:12:09.000000",
  "date_fiche": "2023-04-05",
  "avis_system": null,
  "decision_at": null,
  "decision_by": null,
  "type_action": "INJECTION",
  "added_for_emp": "043063",
  "failed_reasons": null,
  "motif_rejected": null,
  "date_avis_system": null,
  "date_modification": "2023-04-13 11:12:09.000000",
  "force_siformation": 0,
  "commentaire_system": null
}, {
  "id": 4,
  "vo": "[{\"debut\":\"2023-04-05 11:00\",\"fin\":\"2023-04-05 12:00\"},{\"debut\":\"2023-04-05 15:00\",\"fin\":\"2023-04-05 18:00\"}]",
  "motif": "TEST",
  "pause": 45,
  "status": "PENDING",
  "site_id": 287,
  "added_by": "000167",
  "timezone": 1,
  "site_name": "MA-HASSANE2",
  "created_at": "2023-04-13 11:12:09.000000",
  "date_fiche": "2023-04-05",
  "avis_system": null,
  "decision_at": null,
  "decision_by": null,
  "type_action": "INJECTION",
  "added_for_emp": "067972",
  "failed_reasons": null,
  "motif_rejected": null,
  "date_avis_system": null,
  "date_modification": "2023-04-13 11:12:09.000000",
  "force_siformation": 0,
  "commentaire_system": null
}];


export const DATA_BLOCKS = {
  "blockVOS": [{
    "id": 614723118,
    "start": "2023-03-21 08:00:00",
    "end": "2023-03-21 10:00:00",
    "type": "PLANNED",
    "activityType": "INSERVICE",
    "blockStatus": "CREATED",
    "label": "Action",
    "timeZone": 0,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "tag": "Planned",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "TO",
    "planningId": 517668593,
    "distribution": "D",
    "tad": false
  }, {
    "id": 614723119,
    "start": "2023-03-21 10:00:00",
    "end": "2023-03-21 10:15:00",
    "type": "PLANNED",
    "activityType": "INSERVICE",
    "blockStatus": "CREATED",
    "label": "Pause",
    "timeZone": 0,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "tag": "Planned",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "TO",
    "planningId": 680300918,
    "distribution": "D",
    "tad": false
  }, {
    "id": 614723120,
    "start": "2023-03-21 10:15:00",
    "end": "2023-03-21 12:30:00",
    "type": "PLANNED",
    "activityType": "INSERVICE",
    "blockStatus": "CREATED",
    "label": "Action",
    "timeZone": 0,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "tag": "Planned",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "TO",
    "planningId": 554570512,
    "distribution": "D",
    "tad": false
  }, {
    "id": 614723121,
    "start": "2023-03-21 12:30:00",
    "end": "2023-03-21 13:30:00",
    "type": "PLANNED",
    "activityType": "OFFSERVICE",
    "blockStatus": "CREATED",
    "label": "Repas",
    "timeZone": 0,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": false,
    "tag": "Planned",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "TO",
    "planningId": 568079336,
    "distribution": "D",
    "tad": false
  }, {
    "id": 614723122,
    "start": "2023-03-21 13:30:00",
    "end": "2023-03-21 15:15:00",
    "type": "PLANNED",
    "activityType": "INSERVICE",
    "blockStatus": "CREATED",
    "label": "Action",
    "timeZone": 0,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "tag": "Planned",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "TO",
    "planningId": 632735829,
    "distribution": "D",
    "tad": false
  }, {
    "id": 614723123,
    "start": "2023-03-21 15:15:00",
    "end": "2023-03-21 15:30:00",
    "type": "PLANNED",
    "activityType": "INSERVICE",
    "blockStatus": "CREATED",
    "label": "Pause",
    "timeZone": 0,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "tag": "Planned",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "TO",
    "planningId": 974200633,
    "distribution": "D",
    "tad": false
  }, {
    "id": 614723124,
    "start": "2023-03-21 15:30:00",
    "end": "2023-03-21 17:00:00",
    "type": "PLANNED",
    "activityType": "INSERVICE",
    "blockStatus": "CREATED",
    "label": "Action",
    "timeZone": 0,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "tag": "Planned",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "TO",
    "planningId": 845846779,
    "distribution": "D",
    "tad": false
  }, {
    "id": 614020374,
    "start": "2023-03-20 09:08:55",
    "end": "2023-03-21 01:00:03",
    "type": "FULFILLED",
    "activityType": "INSERVICE",
    "blockStatus": "PROCESSED",
    "timeZone": 120,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "locked": "UNLOCKED",
    "tag": "Fulfilled_system",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "HMP",
    "distribution": "D",
    "tad": false
  }, {
    "id": 614616486,
    "start": "2023-03-21 10:24:03",
    "end": "2023-03-21 10:24:08",
    "type": "FULFILLED",
    "activityType": "INSERVICE",
    "blockStatus": "PROCESSED",
    "timeZone": 120,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "locked": "UNLOCKED",
    "tag": "Fulfilled_system",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "HMP",
    "distribution": "D",
    "tad": false
  }, {
    "id": 614616523,
    "start": "2023-03-21 10:24:16",
    "end": "2023-03-23 09:12:24",
    "type": "FULFILLED",
    "activityType": "INSERVICE",
    "blockStatus": "PROCESSED",
    "timeZone": 120,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": true,
    "locked": "UNLOCKED",
    "tag": "Fulfilled_system",
    "durationBreak": 0,
    "validatedBy": null,
    "reclamationStatus": null,
    "source": "HMP",
    "distribution": "D",
    "tad": false
  }, {
    "id": 615001607,
    "start": "2023-03-21 00:00:00",
    "end": "2023-03-21 01:00:03",
    "type": "INCOHERENCE",
    "activityType": "INSERVICE",
    "blockStatus": "VALIDATED",
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": false,
    "locked": "UNLOCKED",
    "tag": "Incoherence",
    "motif": {"code": "ARRIVEEANTICIPEE", "label": "Arrivée Anticipée", "type": "PLUS", "paied": false, "country": "*"},
    "validatedBy": {
      "id": 643,
      "username": "004759",
      "email": "aouatif.chafki@intelcia.com",
      "firstName": "Aouatif",
      "lastName": "Chafki",
      "authority": "ROLE_TL",
      "formation": false,
      "dateEntree": "01/08/2005",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Aouatif Chafki 004759",
      "fullName": "Aouatif Chafki"
    },
    "validated": "2023-03-22 08:49:16",
    "reclamationStatus": null,
    "source": "SYSTEM",
    "distribution": "D",
    "tad": false,
    "ticketId": ""
  }, {
    "id": 615001608,
    "start": "2023-03-21 08:00:00",
    "end": "2023-03-21 10:24:16",
    "type": "INCOHERENCE",
    "activityType": "OFFSERVICE",
    "blockStatus": "VALIDATED",
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": false,
    "locked": "UNLOCKED",
    "tag": "Incoherence",
    "updatedBy": "004759",
    "motif": {"code": "TRAVAILNONLOGUE", "label": "Travail non logué", "type": "MINUS", "paied": true, "country": "*"},
    "validatedBy": {
      "id": 643,
      "username": "004759",
      "email": "aouatif.chafki@intelcia.com",
      "firstName": "Aouatif",
      "lastName": "Chafki",
      "authority": "ROLE_TL",
      "formation": false,
      "dateEntree": "01/08/2005",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Aouatif Chafki 004759",
      "fullName": "Aouatif Chafki"
    },
    "validated": "2023-03-22 08:49:16",
    "reclamationStatus": null,
    "source": "SYSTEM",
    "planningId": 517668593,
    "distribution": "D",
    "tad": false,
    "ticketId": ""
  }, {
    "id": 615001611,
    "start": "2023-03-21 10:24:16",
    "end": "2023-03-21 12:30:00",
    "type": "FULFILLED",
    "activityType": "INSERVICE",
    "blockStatus": "VALIDATED",
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": false,
    "locked": "UNLOCKED",
    "tag": "Fulfilled",
    "validatedBy": {
      "id": 643,
      "username": "004759",
      "email": "aouatif.chafki@intelcia.com",
      "firstName": "Aouatif",
      "lastName": "Chafki",
      "authority": "ROLE_TL",
      "formation": false,
      "dateEntree": "01/08/2005",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Aouatif Chafki 004759",
      "fullName": "Aouatif Chafki"
    },
    "validated": "2023-03-22 08:49:16",
    "reclamationStatus": null,
    "source": "SYSTEM",
    "planningId": 554570512,
    "distribution": "D",
    "tad": false
  }, {
    "id": 615001610,
    "start": "2023-03-21 12:30:00",
    "end": "2023-03-21 13:30:00",
    "type": "INCOHERENCE",
    "activityType": "INSERVICE",
    "blockStatus": "VALIDATED",
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": false,
    "locked": "UNLOCKED",
    "tag": "Incoherence",
    "motif": {"code": "ARRIVEEANTICIPEE", "label": "Arrivée Anticipée", "type": "PLUS", "paied": false, "country": "*"},
    "validatedBy": {
      "id": 643,
      "username": "004759",
      "email": "aouatif.chafki@intelcia.com",
      "firstName": "Aouatif",
      "lastName": "Chafki",
      "authority": "ROLE_TL",
      "formation": false,
      "dateEntree": "01/08/2005",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Aouatif Chafki 004759",
      "fullName": "Aouatif Chafki"
    },
    "validated": "2023-03-22 08:49:16",
    "reclamationStatus": null,
    "source": "SYSTEM",
    "planningId": 568079336,
    "distribution": "D",
    "tad": false,
    "ticketId": ""
  }, {
    "id": 615001612,
    "start": "2023-03-21 13:30:00",
    "end": "2023-03-21 17:00:00",
    "type": "FULFILLED",
    "activityType": "INSERVICE",
    "blockStatus": "VALIDATED",
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": false,
    "locked": "UNLOCKED",
    "tag": "Fulfilled",
    "validatedBy": {
      "id": 643,
      "username": "004759",
      "email": "aouatif.chafki@intelcia.com",
      "firstName": "Aouatif",
      "lastName": "Chafki",
      "authority": "ROLE_TL",
      "formation": false,
      "dateEntree": "01/08/2005",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Aouatif Chafki 004759",
      "fullName": "Aouatif Chafki"
    },
    "validated": "2023-03-22 08:49:16",
    "reclamationStatus": null,
    "source": "SYSTEM",
    "planningId": 632735829,
    "distribution": "D",
    "tad": false
  }, {
    "id": 615001609,
    "start": "2023-03-21 17:00:00",
    "end": "2023-03-21 23:59:59",
    "type": "INCOHERENCE",
    "activityType": "INSERVICE",
    "blockStatus": "VALIDATED",
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "logged": false,
    "locked": "UNLOCKED",
    "tag": "Incoherence",
    "motif": {"code": "ARRIVEEANTICIPEE", "label": "Arrivée Anticipée", "type": "PLUS", "paied": false, "country": "*"},
    "validatedBy": {
      "id": 643,
      "username": "004759",
      "email": "aouatif.chafki@intelcia.com",
      "firstName": "Aouatif",
      "lastName": "Chafki",
      "authority": "ROLE_TL",
      "formation": false,
      "dateEntree": "01/08/2005",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Aouatif Chafki 004759",
      "fullName": "Aouatif Chafki"
    },
    "validated": "2023-03-22 08:49:16",
    "reclamationStatus": null,
    "source": "SYSTEM",
    "distribution": "D",
    "tad": false,
    "ticketId": ""
  }],
  "breakVOS": [{
    "id": 32322591,
    "duration": 0,
    "user": {
      "id": 582,
      "username": "000741",
      "email": "yassmine.mgassy@intelcia.com",
      "firstName": "Yassmine",
      "lastName": "M Gassy",
      "authority": "ROLE_USER",
      "formation": false,
      "dateEntree": "06/04/2010",
      "lastCross": "2023-04-05T00:01:00",
      "fullNameWithMatricule": "Yassmine M Gassy 000741",
      "fullName": "Yassmine M Gassy"
    },
    "start": "2023-03-16T17:08:16"
  }],
  "config": {"startPaie": 0, "endPaie": 0, "alreadyExists": false}
};



// WEBPACK FOOTER //
// ./src/app/modules/injection/exports.ts